import React, { Component, useState, Fragment } from "react";
//import compose from 'recompose/compose';
import { connect } from "react-redux";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import DatePicker from "react-datepicker";
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { withStyles } from "@material-ui/core/styles";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from "@material-ui/core/Typography";
import { shopActions, alertActions } from "../../_actions";
import { apiConstants } from '../../_constants/api.constants';
import { uploadService } from "../../_services/upload.service";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import loader from '../../_assets/Ring-Loading.gif';

import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
//-- CSS for Material
const styles = theme => ({
    root: {
        maxWidth: '75%',
        margin: '0 auto',
    },
    paddingBox: {
        padding: theme.spacing(2)
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '100%'

    },
    newPasswordRequired: {
        padding: '2px 10px 2px 10px',
        borderRadius: '30px',
        color: 'white',
        backgroundColor: 'grey',
        cursor: 'pointer'
    },
    addressField: {
        border: '1px solid lightgrey',
        borderRadius: '5px',
        padding: '5px',
        width: '100%'
    }
});

class EditShopkeeper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editShopKeeeperId: '',
            country: '',
            region: '',
            defaultData: {},
            validated: { errors: { coupon_title: "", description: "" } },
            file: null,
            src: null,
            crop: {
                unit: "%",
                width: 100,
                aspect: 1 / 1
            },
            croppedImageUrl: null,
            nowCropImage: false,
            notifyPopup: false,
            dataSavedSuccess: false,
            shopkeeperData: [],
            imageChangesOrNot: 0,
            fullAddress: ''
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const { match } = this.props;
        const shopkkeperId = match.params.id
        this.setState({ editShopKeeeperId: shopkkeperId });
        const obj = {};
        obj.shopkeeprId = shopkkeperId;
        dispatch(shopActions.getShopKeeper(apiConstants.GET_SHOPKEEPER, obj));
    }


    handleDateChange = date => {
        this.setState({ selectedDate: date });
    }


    selectCountry = (val) => {
        const { defaultData } = this.state;
        this.setState({
            country: val
        });
    }

    // this life cycle method trigger when new data arrive on component
    componentWillReceiveProps(props) {
        if (props.getShopkeeper !== undefined) {
            if (props.getShopkeeper.data.shopkeeper) {
                const shopeeprUser = props.getShopkeeper.data.shopkeeper[0];
                this.setState({
                    shopkeeperData: props.getShopkeeper.data.shopkeeper[0],
                    firstname: shopeeprUser.firstname,
                    lastname: shopeeprUser.lastname,
                    selectedDate: new Date(shopeeprUser.dob),
                    // password: shopeeprUser.password,
                    email: shopeeprUser.email,
                    contact_number: shopeeprUser.mobile_number,
                    street: shopeeprUser.locations[0].street,
                    city: shopeeprUser.locations[0].city,
                    country: shopeeprUser.locations[0].country,
                    region: shopeeprUser.locations[0].state,
                    zipcode: shopeeprUser.locations[0].zipCode,

                    shop_title: shopeeprUser.shopData[0].title,
                    shop_licence: shopeeprUser.shopData[0].licenceNo,
                    shop_contact: shopeeprUser.shopData[0].contactNo,
                    // shop_logo: shopeeprUser.shopData[0].shopLogo,
                    shop_street: shopeeprUser.shopData[0].address.street,
                    shop_city: shopeeprUser.shopData[0].address.city,
                    shop_country: shopeeprUser.shopData[0].address.country,
                    shop_region: shopeeprUser.shopData[0].address.state,
                    shop_zipcode: shopeeprUser.shopData[0].address.zipCode,
                    lat: shopeeprUser.shopData[0].address.lat,
                    long: shopeeprUser.shopData[0].address.long,
                    fullAddress: shopeeprUser.shopData[0].address.fullAddress,
                })
            }
        }
        // send page to shopkeepr list if data is updates
        if (props.updateShopAndShopkeeperList !== undefined &&
            props.updateShopAndShopkeeperList.updateShopAndShopkeeper !== undefined &&
            props.updateShopAndShopkeeperList.updateShopAndShopkeeper.data !== undefined &&
            props.updateShopAndShopkeeperList.updateShopAndShopkeeper.data.success === true) {
            this.setState({ dataSavedSuccess: true });
            setTimeout(function () { props.history.push('/shopkeeper'); }, 3000);
        }
    }

    selectRegion = (val) => {
        const { defaultData } = this.state;
        this.setState({
            region: val
        });
    }

    selectCountry_shop = (val) => {
        const { defaultData } = this.state;
        this.setState({
            shop_country: val
        });
    }

    selectRegion_shop = (val) => {
        const { defaultData } = this.state;
        this.setState({
            shop_region: val
        });
    }

    /*
    * Validate form field before saving
    */
    handleValidation() {
        const { siteConstants } = this.props.language;
        const fieldToValidate = [
            'firstname',
            'lastname',
            'selectedDate',
            'email',
            'contact_number',
            'street',
            'city',
            'country',
            'region',
            'zipcode',
            'shop_title',
            'shop_licence',
            'shop_contact',
            'shop_logo',
            // 'shop_street',
            // 'shop_city',
            // 'shop_country',
            // 'shop_region',
            'shop_city'
        ];

        //const fields = this.state.defaultData;
        let formIsValid = true;
        let obj = {}
        const pattern = new RegExp("^[0-9]{10}$");
        const emailPtrn = new RegExp("^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$");

        // imageChangesOrNot
        fieldToValidate.map((data) => {
            if (data === 'shop_logo') {
                if (this.state.imageChangesOrNot !== 0 && (this.state[data] === "" || this.state[data] === undefined)) {
                    formIsValid = false;
                    obj[data] = siteConstants.ERR_CAN_NOT_BLANK;
                    return false;
                }

            } else if (this.state[data] === "" || this.state[data] === undefined) {
                formIsValid = false;
                obj[data] = siteConstants.ERR_CAN_NOT_BLANK;
                return false;
            } else if (data === "email" && !emailPtrn.test(this.state[data])) {
                obj[data] = siteConstants.ERR_EMAIL_NOT_VALID;
                return false;
            } else if (data === "contact_number" && !pattern.test(this.state[data])) {
                obj[data] = siteConstants.ERR_CONTACT_NOT_VALID;
                return false;
            } else if (data === "shop_contact" && !pattern.test(this.state[data])) {
                obj[data] = siteConstants.ERR_CONTACT_NOT_VALID;
                return false;
            }
        })



        this.setState({
            validated: {
                errors: obj
            }
        });

        return formIsValid;
    }

    /*
    *   we are setting the Values
    */
    handleChange = e => {
        const { name, value } = e.target;
        const { defaultData } = this.state;
        this.setState({
            [name]: value
        });
    };

    // gogole address fetch module
    handleChangeAddress = fullAddress => { this.setState({ fullAddress }); };

    handleSelect = address => {

        let street = '', city = '', state = '', country = '', zipcode = '', lat = '', long = '';
        geocodeByAddress(address)
            //.then(results => getLatLng(results[0]))
            .then(results => {
                const { defaultData } = this.state;
                if (results[0].address_components !== undefined && results[0].address_components.length > 0) {
                    results[0].address_components.map((data, index) => {

                        if (data.types.indexOf("street_number") !== -1) { street = data.long_name + ' '; }
                        if (data.types.indexOf("route") !== -1) { street = street + data.long_name; }
                        if (data.types.indexOf("locality") !== -1) { city = data.long_name; }
                        if (data.types.indexOf("administrative_area_level_1") !== -1) { state = data.long_name; }
                        if (data.types.indexOf("country") !== -1) { country = data.long_name; }
                        if (data.types.indexOf("postal_code") !== -1) { zipcode = data.long_name; }
                    });
                }

                var resp = results[0];


                getLatLng(results[0]).then(results => {
                    if (results) {
                        lat = results.lat;
                        long = results.lng;

                        this.setState({
                            shop_street: street,
                            shop_city: city,
                            shop_country: country,
                            shop_region: state,
                            shop_zipcode: zipcode,
                            fullAddress: resp.formatted_address,
                            lat: lat,
                            long: long
                        });

                    }
                });

            });
        // .then(latLng => //console.log('Success', latLng))
        // .catch(error => console.error('Error', error));
    };

    // Trigger when a image selected to upload as shop logo
    onChange = (e) => {

        const { name, value } = e.target;
        const { defaultData } = this.state;

        const types = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!types.includes(e.target.files[0].type)) {
            alert('We only support png/jpg images at the moment', 'danger');
        } else {
            const files = e.target.files;

            this.setState({
                croppedImage: files[0]
                // [name]: value,
                // file: e.target.files[0],
                // nowCropImage: true,
                // imageChangesOrNot: 1
            });

            //
            // const fileReader = new FileReader()
            // fileReader.onloadend = () => {
            //     this.setState({ src: fileReader.result })
            // }
            // fileReader.readAsDataURL(e.target.files[0])
        }
    }

    handleClose = (e) => {
        this.setState({
            nowCropImage: false
        });
    }


    handleSubmit = e => {
        e.preventDefault();
        const { dispatch } = this.props;

        if (this.handleValidation()) {
            //set the state to true, so the imaeg is uploading popup gets open
            this.setState({ notifyPopup: true });


            const fields = this.state;
            const shopData = {};

            shopData.userId = fields.editShopKeeeperId;
            shopData.firstname = fields.firstname;
            shopData.lastname = fields.lastname;
            shopData.dob = fields.selectedDate;
            shopData.password = fields.password !== undefined && fields.password !== '' ? fields.password : '';
            shopData.email = fields.email;
            shopData.contact_number = fields.contact_number;
            shopData.street = fields.street;
            shopData.city = fields.city;
            shopData.country = fields.country;
            shopData.region = fields.region;
            shopData.zipcode = fields.zipcode !== undefined && fields.zipcode ? fields.zipcode : '';
            shopData.shop_title = fields.shop_title;
            shopData.shop_licence = fields.shop_licence;
            shopData.shop_contact = fields.shop_contact;

            shopData.shop_street = fields.shop_street;
            shopData.shop_city = fields.shop_city;
            shopData.shop_country = fields.shop_country;
            shopData.shop_region = fields.shop_region;
            shopData.shop_zipcode = fields.shop_zipcode;
            shopData.shopfullAddress = fields.fullAddress;
            shopData.shoplat = fields.lat;
            shopData.shoplong = fields.long;


            if (this.state.croppedImage !== undefined && this.state.croppedImage) {
                // if new imaeg is uploaded by user them upload it image is
                const formData = new FormData();
                formData.append('shopLogo', this.state.croppedImage);
                uploadService.uploadImage(apiConstants.SAVE_SHOP_LOGO, formData).then(
                    res => {
                        shopData.shopLogo = res.data.data;
                        this.props.dispatch(
                            shopActions.updateShopAndShopKeeper(
                                apiConstants.UPDATE_SHOP_AND_SHOPKEEPER,
                                shopData
                            )
                        );

                    },
                    error => {
                        this.setState({ notifyPopup: false });
                        dispatch(alertActions.error(error.response.data.error));
                    }
                );

            }
            else {

                this.props.dispatch(
                    shopActions.updateShopAndShopKeeper(
                        apiConstants.UPDATE_SHOP_AND_SHOPKEEPER,
                        shopData
                    )
                );

            }





        }
    };



    onImageLoaded = (image) => {
        this.imageRef = image
    }

    onCropChange = (crop) => {
        this.setState({ crop });
        console.log("crop change", crop)
    }

    onCropComplete = (crop) => {
        const { dispatch } = this.props;

        if (this.imageRef && crop.width && crop.height) {
            this.getCroppedImg(this.imageRef, crop, "croppedimg.jpg").then(
                data => {
                    console.log("crop complete", data);
                    this.setState({ croppedImageUrl: data })
                    this.setState({ croppedImage: data })
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            )
        }
    }

    closeDialog = () => {
        const { defaultData } = this.state;
        this.setState({
            shop_logo: "",
            nowCropImage: false,
            file: null,
            src: null,
            imageChangesOrNot: 0
        });

    }

    getCroppedImg(image, pixelCrop, fileName) {
        const canvas = document.createElement('canvas');
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );
        return new Promise((resolve, reject) => {
            canvas.toBlob(file => {
                file.name = fileName;
                resolve(file);
            }, 'image/jpeg');
        });
    }
    dataURLtoFile(dataurl, filename) {
        let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        let croppedImage = new File([u8arr], filename, { type: mime });
        this.setState({ croppedImage: croppedImage })

    }

    render() {
        const { children, classes, onClose, openPopup, handleClose } = this.props;
        const { siteConstants } = this.props.language;

        return (

            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/shopkeeper">{siteConstants.MENU_SHOPKEEPER}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    Data
                                </li>

                                <li style={{ paddingLeft: "730px" }}>
                                    <a href="/shopkeeper" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <Card className={classes.root}>
                                <form role="form" className="col-md-12 col-xs-12" autoComplete="off" encType="multipart/form-data">
                                    <CardContent>
                                        <div className="row">

                                            <div className="col-md-12 fontColorHeading">
                                                <b>{siteConstants.LABEL_USER_SECTION_HEAD}</b>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_FIRST_NAME}</label>
                                                    <input
                                                        className="form-control"
                                                        name="firstname"
                                                        placeholder={siteConstants.LABEL_FIRST_NAME}
                                                        value={this.state.firstname}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.firstname}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_LAST_NAME}</label>
                                                    <input
                                                        className="form-control"
                                                        name="lastname"
                                                        placeholder={siteConstants.LABEL_LAST_NAME}
                                                        value={this.state.lastname}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.lastname}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_DOB}</label><br />
                                                    <DatePicker
                                                        selected={this.state.selectedDate}
                                                        onChange={this.handleDateChange}
                                                        className="form-control"
                                                        popperPlacement='top-start'
                                                    />
                                                    <input type="text" style={{ display: "none" }} />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.datePicker}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_PASSWORD} <span className={classes.newPasswordRequired} title={siteConstants.LABEL_SHOP_NEW_PASSWORD_IF_REQUIRED}>?</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="password"
                                                        placeholder={siteConstants.LABEL_PASSWORD}
                                                        value={this.state.password}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.password}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_EMAIL}</label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        placeholder={siteConstants.LABEL_EMAIL}
                                                        value={this.state.email}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.email}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_CONTACT_NO}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="contact_number"
                                                        placeholder={siteConstants.LABEL_CONTACT_NO}
                                                        value={this.state.contact_number}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.contact_number}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 fontColorHeading">
                                                <b>{siteConstants.LABEL_LOCATION_SECTION}</b>
                                            </div>
                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_STREET}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="street"
                                                        placeholder={siteConstants.LABEL_STREET}
                                                        value={this.state.street}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.street}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_CITY}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="city"
                                                        placeholder={siteConstants.LABEL_CITY}
                                                        value={this.state.city}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.city}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_COUNTRY}</label>
                                                    <CountryDropdown
                                                        className="form-control"
                                                        value={this.state.country}
                                                        onChange={(val) => this.selectCountry(val)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.country}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_STATE}</label>
                                                    <RegionDropdown
                                                        className="form-control"
                                                        country={this.state.country}
                                                        value={this.state.region}
                                                        onChange={(val) => this.selectRegion(val)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.region}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_ZIP}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="zipcode"
                                                        placeholder={siteConstants.LABEL_ZIP}
                                                        value={this.state.zipcode}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.zipcode}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-12 fontColorHeading">
                                                <b>{siteConstants.LABEL_SHOP_SECTION_HEAD}</b>
                                            </div>
                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_SHOP_TITLE}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="shop_title"
                                                        placeholder={siteConstants.LABEL_SHOP_TITLE}
                                                        value={this.state.shop_title}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_title}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_SHOP_LICENCE}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="shop_licence"
                                                        placeholder={siteConstants.LABEL_SHOP_LICENCE}
                                                        value={this.state.shop_licence}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_licence}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_SHOP_CONTACT}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="shop_contact"
                                                        placeholder={siteConstants.LABEL_SHOP_CONTACT}
                                                        value={this.state.shop_contact}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_contact}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_SHOP_LOGO} <span className={classes.newPasswordRequired} title={siteConstants.LABEL_SHOP_NEW_IMAGE_IF_REQUIRED}>?</span></label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="shop_logo"
                                                        placeholder={siteConstants.LABEL_SHOP_LOGO}
                                                        value={this.state.shop_logo}
                                                        onChange={(e) => this.onChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_logo}
                                                    </span>
                                                </div>
                                            </div>

                                            {/*
                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_STREET}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="shop_street"
                                                        placeholder={siteConstants.LABEL_STREET}
                                                        value={this.state.shop_street}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_street}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_CITY}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="shop_city"
                                                        placeholder={siteConstants.LABEL_CITY}
                                                        value={this.state.shop_city}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_city}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_COUNTRY}</label>
                                                    <CountryDropdown
                                                        className="form-control"
                                                        value={this.state.shop_country}
                                                        onChange={(val) => this.selectCountry_shop(val)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_country}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_STATE}</label>
                                                    <RegionDropdown
                                                        className="form-control"
                                                        country={this.state.shop_country}
                                                        value={this.state.shop_region}
                                                        onChange={(val) => this.selectRegion_shop(val)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_region}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-xs-6">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_ZIP}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="shop_zipcode"
                                                        placeholder={siteConstants.LABEL_ZIP}
                                                        value={this.state.shop_zipcode}
                                                        onChange={(e) => this.handleChange(e)}
                                                    />
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_zipcode}
                                                    </span>
                                                </div>
                                            </div> */}

                                            <div className="col-md-12 col-xs-12">
                                                <div className="form-group">
                                                    <label>{siteConstants.LABEL_POPUP_LABLE}</label>
                                                    <PlacesAutocomplete
                                                        className="form-control"
                                                        value={this.state.fullAddress}
                                                        onChange={this.handleChangeAddress}
                                                        onSelect={this.handleSelect}
                                                    >
                                                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                            <div>
                                                                <input
                                                                    {...getInputProps({
                                                                        placeholder: 'Search Places ...',
                                                                        className: classes.addressField + ' location-search-input',
                                                                    })}
                                                                />
                                                                <div className="autocomplete-dropdown-container">
                                                                    {loading && <div>Loading...</div>}
                                                                    {suggestions.map(suggestion => {
                                                                        const className = suggestion.active
                                                                            ? 'suggestion-item--active'
                                                                            : 'suggestion-item';
                                                                        // inline style for demonstration purpose
                                                                        const style = suggestion.active
                                                                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                                                        return (
                                                                            <div
                                                                                {...getSuggestionItemProps(suggestion, {
                                                                                    className,
                                                                                    style,
                                                                                })}
                                                                            >
                                                                                <span>{suggestion.description}</span>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </PlacesAutocomplete>
                                                    <span className="my-error">
                                                        {this.state.validated.errors.shop_zipcode}
                                                    </span>
                                                </div>
                                            </div>



                                        </div>

                                    </CardContent>

                                    <CardActions>
                                        <Button variant="contained">CANCEL</Button>
                                        <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>SAVE</Button>
                                    </CardActions>
                                </form>

                            </Card>

                            <br />
                        </div>
                        {/* <!-- /.container-fluid --> */}
                    </div>
                    {/* <!-- End of Main Content --> */}
                    <Footer />

                    {/* resize image before uploading */}
                    <Dialog
                        open={this.state.nowCropImage}
                        onClose={() => this.handleClose()}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="crop-image-dialog-title">{siteConstants.CROP_IMAGE}</DialogTitle>

                        {this.state.src && (
                            <ReactCrop
                                src={this.state.src}
                                crop={this.state.crop}
                                onImageLoaded={(e) => this.onImageLoaded(e)}
                                onComplete={(e) => this.onCropComplete(e)}
                                onChange={(e) => this.onCropChange(e)}
                            />
                        )}
                        <DialogActions>
                            <Button onClick={() => this.closeDialog()} color="primary">
                                {siteConstants.CANCEL_CROPPING}
                            </Button>
                            <Button onClick={() => this.handleClose()} color="primary" autoFocus>
                                {siteConstants.DONE_CROPPING}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* Notify image is uploading */}
                    <Dialog
                        open={this.state.notifyPopup}
                        onClose={() => this.handleClose()}
                        aria-labelledby="dialog-title"
                        aria-describedby="dialog-description"
                    >
                        <DialogTitle id="crop-image-dialog-title">{siteConstants.UPLOADING_IMAGE}</DialogTitle>
                        <img className={classes.loaderImg} src={loader} />
                        <DialogActions></DialogActions>
                    </Dialog>

                    {/* Notify that data saveds and redirecting */}
                    <Dialog
                        open={this.state.dataSavedSuccess}
                        aria-labelledby="saved-title"
                        aria-describedby="saved-description"
                    >
                        <DialogTitle id="crop-image-dialog-title">{siteConstants.LABLE_UPDATE_SHOP}</DialogTitle>
                        <img className={classes.loaderImg} src={loader} />
                        <DialogActions></DialogActions>
                    </Dialog>

                </div>
            </div>
        );
    }
}
//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, getShopkeeper, updateShopAndShopkeeperList } = state;
    return {
        language,
        getShopkeeper,
        updateShopAndShopkeeperList
    };
}

//export default compose(withStyles(styles), connect(mapStateToProps))(EditShopkeeper)

const connectedEditShopkeeper = connect(mapStateToProps)(withStyles(styles)(EditShopkeeper));
export { connectedEditShopkeeper as EditShopkeeper };
